module.exports = __webpack_public_path__ + "img/p22.aa4b1243.png";